import { toggle_loader, disable_loader } from './loader.js';
document.addEventListener('DOMContentLoaded', function () {
  var blog_select = document.getElementById('blog-select');
  var case_studies_select = document.getElementById('case-study-select');
  var case_studies_select_2 = document.getElementById('case-study-select-2');
  var careers_select = document.getElementById('careers-select');

  if (blog_select) {
    blog_select.onchange = function () {
      toggle_loader();

      if (blog_select.value && blog_select.value != '0') {
        window.location.href = blog_select.parentNode.dataset.categories + '/' + blog_select.value;
        console.log('URL IS ' + window.location.href);
      } else {
        window.location.href = blog_select.parentNode.dataset.all;
      }
    };
  }

  if (case_studies_select) {
    case_studies_select.onchange = function () {
      toggle_loader();

      if (case_studies_select.value && case_studies_select.value != '0') {
        window.location.href = case_studies_select.parentNode.dataset.categories + '/' + case_studies_select.value;
      } else {
        window.location.href = case_studies_select.parentNode.dataset.all;
      }
    };
  }

  if (case_studies_select_2) {
    case_studies_select_2.onchange = function () {
      toggle_loader();

      if (case_studies_select_2.value && case_studies_select_2.value != '0') {
        window.location.href = case_studies_select_2.parentNode.dataset.categories + '/' + case_studies_select_2.value;
      } else {
        window.location.href = case_studies_select_2.parentNode.dataset.all;
      }
    };
  }

  if (careers_select) {
    careers_select.onchange = function () {
      toggle_loader();

      if (careers_select.value && careers_select.value != '0') {
        window.location.href = careers_select.parentNode.dataset.categories + '/' + careers_select.value;
      } else {
        window.location.href = careers_select.parentNode.dataset.all;
      }
    };
  }
});